module.exports = "/static/assets/45d38638d4092932841dbdbc6dbfe47e.png";